<template>
  <div>
    <h5>Would you like to create a project using your search criteria?</h5>
    <div style="text-align: center">
      <button type="button" @click="createProject" class="btn btn-fill btn-info">
        Yes
      </button>
      <button type="button" @click="closeModal" class="btn btn-fill btn-info">
        No
      </button>
    </div>
  </div>
</template>

<script>
  import Constants from 'src/utilities/constants'

  export default {
    props: ['data'],
    methods: {
      createProject () {
        if (this.data && this.data === Constants.CREATE_PROJECT.FROM_PROJECT_SEARCH) {
          this.$eventHub.$emit('show-modal-1', 'Create Project', {showButtons: true, source: this.data}, '85%')
          setTimeout(() => {
            this.$eventHub.$emit('copyQueryToCreate')
          }, Constants.TIME.MILLIS.QUARTER_SECOND)
        }
        if (this.data && this.data === Constants.CREATE_PROJECT.FROM_PROJECT_SEARCH_WIZARD) {
          this.$eventHub.$emit('copyQueryToCreateWizard')
        }
        this.closeModal()
      },
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>
